/**
 * CharacterIcon — small adventurer icon for inline-in-button contexts.
 *
 * Replaces the raw emoji (🦊 🐙 🦉) that used to sit next to adventurer
 * names in tight UI — 16-24px buttons where emoji rendering is
 * inconsistent across OSes and looks non-professional.
 *
 * The PNG assets live at /characters/<id>.png and are generated via the
 * ChatGPT/Codex brand playbook. Falls back to invisible on asset-missing
 * so the button label still reads.
 */
import type { AdventurerId } from './AdventurerStamp';

interface Props {
  id: AdventurerId;
  size?: number;
  className?: string;
}

export default function CharacterIcon({ id, size = 18, className }: Props) {
  return (
    <img
      src={`/characters/${id}.png`}
      alt=""
      aria-hidden
      width={size}
      height={size}
      className={className}
      style={{
        width: size,
        height: size,
        display: 'inline-block',
        objectFit: 'contain',
        verticalAlign: 'middle',
      }}
      onError={(e) => {
        (e.currentTarget as HTMLImageElement).style.visibility = 'hidden';
      }}
    />
  );
}
